module.exports = __webpack_public_path__ + "static/media/30OIOS1.0f38c752.jpg";